import { useState, Fragment, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ReactSVG } from "react-svg";
import { formatTime } from "../../helpers/helper";
import { FaRegTrashAlt, FaSearch, FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import api from "../../api/api";
import { useAppDispatch } from "../../store/store";
import { setLoading } from "../../store/slice/utilSlice";
import { IoIosArrowBack } from "react-icons/io";
import { useTranslation } from "react-i18next";

type Props = {}

const Cart = (props: Props) => {
    let cartTotalPrice = 0;
    const [quantityCount] = useState(1);
    const dispatch = useAppDispatch()
    const [cartItems, setCartItems] = useState([])
    const [innerLoading, setInnerLoading] = useState(false)
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [notificationCount, setNotificationCount] = useState(0)

    useEffect(() => {
        getCartItems()
        getOrderNotificationCount()
    }, [])

    function getOrderNotificationCount() {
        // get payment notification count
        api.get(`${process.env.PUBLIC_URL}/order/notification/summary`).then(res => {
            console.log("res notif", res)
            setNotificationCount(res.data.data.seen_count)
        }).catch(err =>{
            toast.error(t("server_error"))
            console.log("err", err)
        })
    }

    function getCartItems() {
        dispatch(setLoading(true))
        api.get(`${process.env.REACT_APP_API_BASE_URL}/cart`).then(res => {
            dispatch(setLoading(false))
            console.log("res cart", res.data.data)
            setCartItems(res.data.data)

        }).catch(err => {
            dispatch(setLoading(false))
            console.log("err cart", err)
        })
    }

    function deleteCartItem(cartItem:any) {
        console.log("deleteCartItem")
        setInnerLoading(true)
        api.delete(`${process.env.PUBLIC_URL}/cart/delete/${cartItem.id}`).then(res => {
            setInnerLoading(false)
            toast.success("Delete from cart")
            console.log("res", res)
            getCartItems()
        }).catch(err =>{
            setInnerLoading(false)
            toast.error(t("server_error"))
            console.log("err", err)
        })
    }

    function handleCheckout() {
        var windowReference = window.open()
        console.log("handleCheckout")
        dispatch(setLoading(true))
        api.post(`${process.env.PUBLIC_URL}/cart/checkout`).then(res => {
            dispatch(setLoading(false))
            console.log("res", res)
            
            const paymentUrl = res.data.payment_url
            if (paymentUrl) {
                windowReference!.location = paymentUrl
            } else {
                toast.error(t("url_not_found"))
            }
        }).catch(err =>{
            dispatch(setLoading(false))
            toast.error(t("server_error"))
            console.log("err", err)
        })
    }

    function parseMonthRange(input: string): string {
        // Define a map to convert month abbreviations to numbers
        const monthMap: { [key: string]: number } = { "Jan": 1, "Feb": 2, "Mar": 3, "Apr": 4, "May": 5, "Jun": 6, "Jul": 7, "Aug": 8, "Sep": 9, "Oct": 10, "Nov": 11, "Dec": 12 };
        
        // Normalize input by removing extra spaces
        input = input.replace(/\s*-\s*/g, '-').trim();
    
        // Split the input into parts and extract months and year
        const [monthRange, year] = input.split(" ");
        const [startMonth, endMonth] = monthRange.split("-").map(month => month.trim());
    
        // Determine start and end years based on input format
        const years = year.split("-").map(yr => parseInt(yr.trim()));
        const startYear = years[0];
        const endYear = years.length > 1 ? years[1] : startYear;
    
        // Generate month-year pairs
        const results: string[] = [];
        const startMonthIndex = monthMap[startMonth];
        const endMonthIndex = monthMap[endMonth];
    
        if (!startMonthIndex || !endMonthIndex) {
            throw new Error(`Invalid month abbreviation: ${startMonth} or ${endMonth}`);
        }
    
        // Loop through the years and months
        for (let year = startYear; year <= endYear; year++) {
            for (let month = (year === startYear ? startMonthIndex : 1); month <= (year === endYear ? endMonthIndex : 12); month++) {
                const monthName = Object.keys(monthMap).find(key => monthMap[key] === month);
                if (monthName) {
                    results.push(`${monthName} ${year}`);
                }
            }
        }
    
        return results.join(", ");
    }
    
    return (
        <div className="pb-24">
            <div className="mb-2 flex items-center justify-between pl-2 pr-3">
                <IoIosArrowBack size={28} color="#000" onClick={() => navigate("/")} />
                <div className="text-lg font-medium flex-1 text-center">{t('cart.cart')}</div>
                <div className="relative">
                    <ReactSVG src={process.env.PUBLIC_URL + "/assets/img/icons/payment-history.svg"} onClick={() => navigate("/payment-history")} className="ml-auto" />

                    {/* Red Notification Badge */}
                    {notificationCount > 0 && (
                    <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-red-500 rounded-full"></span>
                    )}
                </div>
            </div>

            <div className="mt-8 px-3">
            {cartItems && cartItems.length >= 1 ? (
                <>
                {cartItems.map((student:any, key:any) => {
                    return (
                        <>
                        <div key={key} className="text-lg font-semibold mt-4">{student.student_name}</div>
                        {student.cart.map((cartItem:any, index:number) => {
                            if (cartItem.type == "course") {
                                cartTotalPrice += cartItem.price
                                return (
                                    <div className="grid grid-cols-5 gap-3 mt-3" key={index}>
                                        <div className="col-span-1 self-center">
                                            {cartItem.course.images && cartItem.course.images.length > 0 ? (
                                                <img src={cartItem.course.images[0]}/>
                                            ):(
                                                <img src={"/assets/img/products/product1.png" }/>
                                            )}
                                        </div>
                                        <div className="col-span-4">
                                            <div className="grid grid-cols-3 gap-1">
                                                <div className="col-span-2">
                                                    <Link to={`/course/${cartItem.course_branch_id}`} className="text-md font-medium">{cartItem.course.name}</Link>
                                                    <div>{cartItem.schedules[0].day}, {formatTime(cartItem.schedules[0].start_time)} - {formatTime(cartItem.schedules[0].end_time)}</div>
                                                </div>
                                                <div className="flex flex-col col-span-1">
                                                    <div className="self-end">
                                                        <div className={`rounded-xl text-center p-1 px-2 text-xs ${ cartItem.status === 'added' ? 'bg-green-500 text-white' : cartItem.status === 'overdue' ? 'bg-red-500 text-white' : 'bg-amber-600 text-white' }`} >
                                                            {cartItem.status === 'added' ? t('cart.newly_added') : cartItem.status === 'overdue' ? t('cart.overdue') : t('cart.due_soon')}
                                                        </div>
                                                    </div>
                                                    <div className="self-end mt-2">
                                                        {innerLoading ? ( <FaSpinner className="animate-spin" /> ) : ( <FaRegTrashAlt size={18} className="mt-1 cursor-pointer" onClick={() => deleteCartItem(cartItem)} /> )}
                                                    </div>
                                                </div>
                                            </div>
            
                                            <div className="grid grid-cols-8 mt-2">
                                                <div className=" whitespace-normal break-words col-span-5" >{parseMonthRange(cartItem.selected_date)}</div>
                                                <div className=" col-span-3 text-end text-lg font-medium">{`RM ${cartItem.price}`}</div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            } else if (cartItem.type == "item") {
                                cartTotalPrice += cartItem.item.price
                                return (
                                    <div className="grid grid-cols-5 gap-3 mt-3" key={index}>
                                        <div className="col-span-1 self-center">
                                            {cartItem.item.images && cartItem.item.images.length > 0 ? (
                                                <img src={cartItem.item.images[0]}/>
                                            ):(
                                                <img src={"/assets/img/products/product1.png" }/>
                                            )}
                                        </div>
                                        <div className="col-span-4">
                                            <div className="grid grid-cols-3 gap-1">
                                                <div className="col-span-2">
                                                    <Link className="text-lg font-medium" to={`/item/${cartItem.item.id}?course_branch_id=${cartItem.item.course_branch_id}`}>{cartItem.item.name}</Link>
                                                </div>
                                                <div className="col-span-1">
                                                    <div className="justify-items-end">
                                                        {innerLoading ? <FaSpinner className="animate-spin"/> : <FaRegTrashAlt size={18} className="justify-self-end mt-1" onClick={() =>{deleteCartItem(cartItem)}}/>}
                                                    </div>
                                                </div>
                                            </div>
                    
                                            <div className="mt-2">
                                                <div className="whitespace-normal break-words" ></div>
                                                <div className="text-end text-lg font-medium">{`RM ${cartItem.item.price}`}</div>
                                            </div>
                                        </div>
                                    </div>
                                )

                            }
                        })}
                        </>
                    )
                })}
                
                <div className="grand-total space-mt--20">
                    <div className="container">
                        <div className="row">
                        <div className="col-12">
                            <div className="text-md font-medium mb-3">{t('cart.sub_total')} <span>RM {cartTotalPrice.toFixed(2)}</span></div>
                            <h4 className="grand-total-title">{t('cart.grand_total')} <span>RM {cartTotalPrice.toFixed(2)}</span></h4>
                            <button onClick={()=>handleCheckout()} type="button" className="text-white text-[16px] leading-none w-full py-[15px] bg-theme border-none rounded-3xl flex items-center justify-center">
                                {innerLoading ? <FaSpinner className="animate-spin" /> : t('cart.proceed_to_checkout')}
                            </button>

                        </div>
                        </div>
                    </div>
                </div>
                </>
            ) : (
                <div className="no-items-found">
                    <div className="no-items-found__image"> <ReactSVG src={process.env.PUBLIC_URL + "/assets/img/icons/cart.svg"} /> </div>
                    <div className="no-items-found__content">
                        <p> {t('cart.no_items_in_cart')} <Link to={process.env.PUBLIC_URL + "/"}>{t('cart.add_some')}</Link> </p>
                    </div>
                </div>
            )}
            </div>
        </div>
    )
}

export default Cart